import { ReactComponent as Plus } from 'assets/icons/icon-plus.svg';

export default Plus;
